import mock from '@/fake-db/mock.js'

const data = {
  users: [
    {
      'id': 275,
      'username': 'candid910',
      'avatar': require('@/assets/images/portrait/small/avatar-s-26.jpg'),
      'email': 'juanita@sartoris.com',
      'name': 'Juanita Sartoris',
      'country': 'Papua New Guinea',
      'role': 'staff',
      'status': 'En Progreso',
      'price': 'Q500.00',
      'is_verified': true,
      'date': '10/10/2020',
      'department': 'Car. Salvador',
      'molecule': 'talidomina',
      'med': 'medi1'
    },
    {
      'id': 75,
      'username': 'Jose Ruano',
      'avatar': require('@/assets/images/portrait/small/avatar-s-26.jpg'),
      'email': 'uno@evolugy.com',
      'name': 'José Ruano',
      'country': 'Papua New Guinea',
      'role': 'staff',
      'price': 'Q500.00',
      'status': 'Completado',
      'is_verified': false,
      'date': '10/26/2020',
      'department': 'Clíniza zona 10',
      'molecule': 'molecula1',
      'med': 'medi2'
    },
    {
      'id': 15,
      'username': 'Christian',
      'avatar': require('@/assets/images/portrait/small/avatar-s-26.jpg'),
      'email': 'uno@evolugy.com',
      'name': 'Christian Mayorga',
      'price': 'Q500.00',
      'country': 'Papua New Guinea',
      'role': 'staff',
      'status': 'Pendiente',
      'is_verified': false,
      'date': '10/26/2020',
      'department': 'Clinica zona 15',
      'molecule': 'molecula1',
      'med': 'medi2'
    },
    {
      'id': 21,
      'username': 'juan',
      'avatar': require('@/assets/images/portrait/small/avatar-s-26.jpg'),
      'email': 'jp@evolugy.com',
      'name': 'Juan Perez',
      'price': 'Q500.00',
      'country': 'Papua New Guinea',
      'role': 'staff',
      'status': 'Completado',
      'is_verified': true,
      'date': '10/31/2020',
      'department': 'Centro Médico',
      'molecule': 'molecula2',
      'med': 'medi3'
    },
    {
      'id': 275,
      'username': 'hola',
      'avatar': require('@/assets/images/portrait/small/avatar-s-26.jpg'),
      'email': 'pedrog@evolugy.com',
      'name': 'Pedro Gronzalez',
      'country': 'Papua New Guinea',
      'role': 'staff',
      'status': 'Completado',
      'price': 'Q500.00',
      'is_verified': false,
      'date': '10/26/2020',
      'department': 'Zona 1',
      'molecule': 'molecula3',
      'med': 'medi4'
    },
  ]
}


mock.onGet('/api/user-management/users').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.users)).reverse()]
})

// GET: Fetch Single User Details
mock.onGet(/\/api\/user-management\/users\/\d+/).reply((request) => {

  const userId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const user = data.users.find((user) => user.id == userId)

  return user ? [200, JSON.parse(JSON.stringify(user))] : [404]
})

// // POST : Add new Item
// mock.onPost("/api/data-list/products/").reply((request) => {

//   // Get event from post data
//   let item = JSON.parse(request.data).item

//   const length = data.products.length
//   let lastIndex = 0
//   if(length){
//     lastIndex = data.products[length - 1].id
//   }
//   item.id = lastIndex + 1

//   data.products.push(item)

//   return [201, {id: item.id}]
// })

// // Update Product
// mock.onPost(/\/api\/data-list\/products\/\d+/).reply((request) => {

//   const itemId = request.url.substring(request.url.lastIndexOf("/")+1)

//   let item = data.products.find((item) => item.id == itemId)
//   Object.assign(item, JSON.parse(request.data).item)

//   return [200, item]
// })

// // DELETE: Remove Item
mock.onDelete(/\/api\/user-management\/users\/\d+/).reply((request) => {

  const userId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.users.findIndex((p) => p.id == userId)
  data.users.splice(itemIndex, 1)
  return [200]
})
